module.exports = __webpack_public_path__ + "static/media/file-jpg.bc739bb6.svg";